<template>
    <div v-select-text="value" style="width: 850px; margin:0 auto; position: relative; border: 3px solid #efefef; padding: 20px;">
        <table style="font-size: 16px;" width="100%">
            <tbody>
            <tr>
                <td width="33.3%" valign="top">
                    <div style="text-align: justify;">
                        Эксперты отмечают, что в России так и не научились производить элитные сорта сыра. При этом ситуация с покупкой сырья для производства элитных сыров усложнилась после введения санкций. Однако на территории России эти обстоятельства стали рассматриваться как драйвер роста для роста локального производства. В связи с увеличением дороговизны и труднодоступности сырья для производства сыров в России стали появляться “сырные продукты”, которые отличаются от “сыра” тем, что имеют в своем составе повышенное содержание растительных жиров (более 33%). Еще одной причиной является уменьшение производства молока в России, которое упало в 2015 на 0,4%, до 21,5 млн. т, а поголовье КРС – на 1,6%, до 20,1 млн голов, по сравнению с тем же периодом прошлого года, по данным Росстата на август этого года. Поголовье коров упало на 2%, до 8,5 млн голов.
                    </div>
                </td>
                <td width="33.3%" align="center" valign="top" style="padding: 0 15px;">
                    <div class="text-xs-center mb-3" style="font-weight: bold; font-size: 18px;">В поисках сыра в России</div>
                    ТОП-10 крупнейших импортеров пальмового масла (данные от 2013г.)

                    <table width="100%" style="margin-top: 20px;">
                        <tbody>
                        <tr>
                            <th></th>
                            <th align="right">тыс. тонн</th>
                        </tr>
                        <tr>
                            <td align="left">Индия</td>
                            <td align="right">8 389,7</td>
                        </tr>
                        <tr>
                            <td align="left">Китай</td>
                            <td align="right">5 979,6</td>
                        </tr>
                        <tr>
                            <td align="left">Нидерланды*</td>
                            <td align="right">2 925,6</td>
                        </tr>
                        <tr>
                            <td align="left">Пакистан</td>
                            <td align="right">2 248,6</td>
                        </tr>
                        <tr>
                            <td align="left">Германия</td>
                            <td align="right">1 467,4</td>
                        </tr>
                        <tr>
                            <td align="left">Италия</td>
                            <td align="right">1 392,2</td>
                        </tr>
                        <tr>
                            <td align="left">США</td>
                            <td align="right">1 373,2</td>
                        </tr>
                        <tr>
                            <td align="left">Испания</td>
                            <td align="right">902,8</td>
                        </tr>
                        <tr>
                            <td align="left">Бангладеш</td>
                            <td align="right">883,7</td>
                        </tr>
                        <tr>
                            <td align="left">Россия</td>
                            <td align="right">770,6</td>
                        </tr>
                        </tbody>
                    </table>

                    <div style="text-align: left; font-size: 14px;">*значительную часть отправляют на экспорт</div>
                </td>
                <td width="33.3%" valign="top">
                    <div style="text-align: justify;">
                        Выходом из этой ситуации для производителей дешевого сыра является пальмовое масло, так, например, в 2015 году ввоз пальмового масла в Россию вырос на четверть и достиг 888,9 тысячи тонн. В 2016 году поставки незначительно сократились – на 0,4% до 885,1 тысячи тонн.
                        <br>Таким образом, основной российский рецепт — замена молочных жиров растительными. Так получается дешевле, и товар дольше хранится. Иногда в тех же целях используют животные жиры. Полученный продукт при этом продают под видом сыра, хотя по Техническому регламенту, сыром он уже считаться не может. Объясняется это тем, что в кризис люди покупают меньше, доходы производителей падают, и поэтому они стараются компенсировать расходы, удешевляя процесс производства.
                    </div>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>
<script>
    import SelectText from '@/directives/select-text.js'

    export default {
        props: {
            value: [Array]
        },
        directives: {
            SelectText
        }
    }
</script>
<style scoped></style>